import React from "react";
import { HeartIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { usageSteps } from "../data/landing";
export function HowItWorksSection() {
  return <section className="bg-sun-light" data-id="element-144" data-mp="uidefij6xtrz">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-145" data-mp="uhc27aqfv18o">
        <SectionHeading title="Comment partager ces moments de foi avec vos enfants ?" data-id="element-146" data-mp="pi8xxsia8z1r" />

        <div className="relative mt-12 md:mt-16" data-id="element-147" data-mp="1sy12m41zosw">
          <div className="absolute left-[16%] right-[16%] top-8 hidden border-t-[3px] border-dashed border-tangerine/50 md:block" aria-hidden="true" data-id="element-148" data-mp="1tpx1y1kbojp" />
          <ol className="relative grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-149" data-mp="aunshrxxqnqo">
            {usageSteps.map((step, i) => <li key={step.title} className="relative flex gap-5 md:flex-col md:items-center md:text-center" data-id="element-150" data-mp="6qzkj85e5q4w" data-mpi={i}>
                <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-tangerine pt-1 font-display text-3xl font-extrabold text-white ring-[5px] ring-white" data-id="element-151" data-mp="1i87qhxvoreb6">
                  {i + 1}
                </span>
                <div data-id="element-152" data-mp="117wg4pl23g43">
                  <h3 className="font-display text-xl font-bold text-royal md:mt-5 md:text-2xl" data-id="element-153" data-mp="11bkcrxlssin1">
                    {step.title}
                  </h3>
                  <p className="mt-2 leading-relaxed text-cocoa md:mx-auto md:max-w-xs" data-id="element-154" data-mp="1a9cnspkhl44m">
                    {step.text}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mx-auto mt-14 flex w-fit items-center gap-3 rounded-full bg-white px-6 pb-2.5 pt-3 text-center font-display text-lg font-bold text-royal-deep md:text-xl" data-id="element-155" data-mp="hm02eiq2b2cw">
          <HeartIcon className="h-5 w-5 shrink-0 fill-rosy text-rosy" aria-hidden="true" data-id="element-156" data-mp="rcbljcibhi4d" />
          Quelques minutes peuvent suffire pour commencer une belle conversation.
        </p>
      </div>
    </section>;
}